var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("router-link", {
    attrs: {
      to: {
        name: "SettingsCanvas",
        params: { uuid: _vm.id, activeStageId: _vm.activeStage.id },
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ href, route, navigate, isActive, isExactActive }) {
          return [
            _c(
              "div",
              { staticClass: "settings-btn", on: { click: navigate } },
              [
                _c("strong", [_vm._v(_vm._s(_vm._f("trans")("All Settings")))]),
                _c("i", { staticClass: "fa lh-inherit fa-chevron-right" }),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }